import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Fetch the selected record directly; it may be outside the current page/filter.
export default function useRecordDeepLink({ parameter, userId, enabled = true, readRecord, onOpen, onError }) {
  const location = useLocation(), navigate = useNavigate();
  const handlers = useRef({ readRecord, onOpen, onError });
  handlers.current = { readRecord, onOpen, onError };
  useEffect(() => {
    const params = new URLSearchParams(location.search), id = params.get(parameter);
    if (!id || !enabled || !userId) return;
    let active = true;
    const consume = () => { params.delete(parameter); const search = params.toString(); navigate({ pathname: location.pathname, search: search ? `?${search}` : '', hash: location.hash }, { replace: true, state: location.state }); };
    (async () => {
      try {
        if (!/^[1-9]\d*$/.test(id) || !Number.isSafeInteger(Number(id))) throw new Error('El identificador del registro no es válido.');
        const record = await handlers.current.readRecord(id);
        if (!active) return;
        if (!record) throw new Error('El registro ya no está disponible.');
        handlers.current.onOpen(record);
      } catch (error) {
        if (active) handlers.current.onError(error.response?.data?.message || error.message || 'No se pudo abrir el registro.');
      } finally { if (active) consume(); }
    })();
    return () => { active = false; };
  }, [parameter, userId, enabled, location.pathname, location.search, location.hash, location.state, navigate]);
}
